import { useMutation } from "@shared/lib/hooks";

import { useCallback } from "react";
import { ADMIN_LIST_QUERY_KEY } from "../constants";
import { CreateAdmin } from "@shared/lib/types";
import { AdminService } from "../servcies/admin.service";
import { ToastService } from "@shared/lib/services";

const QUERY_OPTIONS = {
  queryKey: ADMIN_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useCreateAdmin() {
  const createAdmin = useCallback(
    (admin: CreateAdmin) =>
      AdminService.createAdmin(admin).catch(async (err) => {
        const responseBody = await err.response.json(); // Get the response body

        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<CreateAdmin>({
    mutationFn: createAdmin,
    options: QUERY_OPTIONS,
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
